import { Helmet } from "react-helmet-async";

function Seo({ seo, slug }) {
  if (!seo) return null;

  const siteUrl = process.env.REACT_APP_UPLOAD_URL;

  // const url = slug === "home"
  //   ? siteUrl
  //   : `${siteUrl}/${slug}`;

  const url = !slug || slug === "home" 
    ? siteUrl 
    : `${siteUrl}/${slug}`;

  const siteName = "Cyblox";

  const pageTitle = seo?.metaTitle || "Home";

  const title = `${pageTitle} | ${siteName}`;
  const description = seo?.metaDescription || "Default description";

  return (
    <Helmet>
      {/* Title */}
      <title>{title}</title>

      {/* Description */}
      <meta name="description" content={description} />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* OpenGraph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Cyblox" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}

export default Seo;
